 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","core-js-js":"core-js-js","default~account-account-module~actions-actions-module~admin-admin-module~data-data-module~login-logi~a01c2fd6":"default~account-account-module~actions-actions-module~admin-admin-module~data-data-module~login-logi~a01c2fd6","default~admin-admin-module~authorize-authorize-module~client-client-module~login-login-module":"default~admin-admin-module~authorize-authorize-module~client-client-module~login-login-module","admin-admin-module":"admin-admin-module","login-login-module":"login-login-module","authorize-authorize-module":"authorize-authorize-module","client-client-module":"client-client-module","dom-js":"dom-js","healthcheck-healthcheck-module":"healthcheck-healthcheck-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","swiper-bundle-44a9b1f9-js":"swiper-bundle-44a9b1f9-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js","clients-clients-module":"clients-clients-module","credentials-credentials-module":"credentials-credentials-module","default~actions-actions-module~add-add-module~assessments-assessments-module~bbs-dashboard-bbs-dashb~f9a628c4":"default~actions-actions-module~add-add-module~assessments-assessments-module~bbs-dashboard-bbs-dashb~f9a628c4","default~add-add-module~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-m~76a03ea1":"default~add-add-module~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-m~76a03ea1","default~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~ccms-ccms~4c3fa73f":"default~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~ccms-ccms~4c3fa73f","default~add-add-module~assessments-assessments-module~bbsi-bbsi-module~ccms-ccms-module~checklists-c~e1327003":"default~add-add-module~assessments-assessments-module~bbsi-bbsi-module~ccms-ccms-module~checklists-c~e1327003","default~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~ccms-ccms~e8d1e0cc":"default~assessments-assessments-module~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~ccms-ccms~e8d1e0cc","default~add-add-module~bbs-dashboard-bbs-dashboard-module~causes-causes-module~checklists-checklists~6f5c51dc":"default~add-add-module~bbs-dashboard-bbs-dashboard-module~causes-causes-module~checklists-checklists~6f5c51dc","default~incident-report-incident-report-module~lagging-indicators-lagging-indicators-module":"default~incident-report-incident-report-module~lagging-indicators-lagging-indicators-module","lagging-indicators-lagging-indicators-module":"lagging-indicators-lagging-indicators-module","checklists-checklists-module":"checklists-checklists-module","default~add-add-module~edit-edit-module~hierarchies-hierarchies-module~view-view-module":"default~add-add-module~edit-edit-module~hierarchies-hierarchies-module~view-view-module","hierarchies-hierarchies-module":"hierarchies-hierarchies-module","causes-causes-module":"causes-causes-module","equipments-equipments-module":"equipments-equipments-module","locations-locations-module":"locations-locations-module","modules-modules-module":"modules-modules-module","safety-rules-safety-rules-module":"safety-rules-safety-rules-module","sources-sources-module":"sources-sources-module","tasks-tasks-module":"tasks-tasks-module","default~edit-edit-module~qr-codes-qr-codes-module":"default~edit-edit-module~qr-codes-qr-codes-module","qr-codes-qr-codes-module":"qr-codes-qr-codes-module","weightings-weightings-module":"weightings-weightings-module","account-account-module":"account-account-module","tabs-bar-tabs-bar-module":"tabs-bar-tabs-bar-module","actions-actions-module":"actions-actions-module","data-data-module":"data-data-module","reports-reports-module":"reports-reports-module","users-users-module":"users-users-module","default~add-add-module~edit-edit-module~hazards-hazards-module~view-view-module":"default~add-add-module~edit-edit-module~hazards-hazards-module~view-view-module","default~add-add-module~edit-edit-module~view-view-module":"default~add-add-module~edit-edit-module~view-view-module","default~add-add-module~edit-edit-module~safe-act-safe-act-module":"default~add-add-module~edit-edit-module~safe-act-safe-act-module","default~add-add-module~edit-edit-module":"default~add-add-module~edit-edit-module","add-add-module":"add-add-module","edit-edit-module":"edit-edit-module","default~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~dashboard-dashboard-module~kpis-kpis-mod~25964519":"default~bbs-dashboard-bbs-dashboard-module~bbsi-bbsi-module~dashboard-dashboard-module~kpis-kpis-mod~25964519","default~bbs-dashboard-bbs-dashboard-module~dashboard-dashboard-module~lagging-dashboard-lagging-dash~8c9253e5":"default~bbs-dashboard-bbs-dashboard-module~dashboard-dashboard-module~lagging-dashboard-lagging-dash~8c9253e5","bbs-dashboard-bbs-dashboard-module":"bbs-dashboard-bbs-dashboard-module","dashboard-dashboard-module":"dashboard-dashboard-module","lagging-dashboard-lagging-dashboard-module":"lagging-dashboard-lagging-dashboard-module","checklists-checklist-module":"checklists-checklist-module","assessments-assessments-module":"assessments-assessments-module","hazard-observation-hazard-observation-module":"hazard-observation-hazard-observation-module","incidents-incidents-module":"incidents-incidents-module","inspections-inspections-module":"inspections-inspections-module","hazards-hazards-module":"hazards-hazards-module","incident-report-incident-report-module":"incident-report-incident-report-module","managements-managements-module":"managements-managements-module","plannings-plannings-module":"plannings-plannings-module","kpis-kpis-module":"kpis-kpis-module","safe-act-safe-act-module":"safe-act-safe-act-module","indicators-indicators-module":"indicators-indicators-module","ccms-ccms-module":"ccms-ccms-module","checklists-checklists-report-module":"checklists-checklists-report-module","bbsi-bbsi-module":"bbsi-bbsi-module","lsi-lsi-module":"lsi-lsi-module","ppi-ppi-module":"ppi-ppi-module","safe-act-safe-act-report-module":"safe-act-safe-act-report-module","view-view-module":"view-view-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
